
<div>
  <el-popover v-if="hasReservations" placement="bottom" trigger="click" popper-class="popup-resa-detail">
    <div slot="reference">
      <div style="cursor: pointer; margin: 0 3px;" class="popup-resa-detail-title" v-html="title"></div>
    </div>
    <div class="popup-resa-detail-content">
      <button @click="printClients" class="print-button">
        <div class="print-icon"></div>
      </button>
      <div class="popup-resa-detail-content-salle" v-for="roomData in getResasDetails" :key="roomData.room">
        <h3 :data-content="roomData.room">{{ roomData.room }}</h3>
        <div v-if="roomData.reservations.length > 0">
          <div v-for="resa in roomData.reservations" :key="resa.nbCouvert"
            style="display: flex; align-items: center; gap: 4px;">
            <p>{{ resa.count }} réservation{{ resa.count > 1 ? 's' : '' }} de {{ resa.nbCouvert }} </p>
            <div class="user-icon"></div>
          </div>
        </div>
        <div v-else>
          <p>Aucune réservation</p>
        </div>
      </div>
    </div>
  </el-popover>
  <div v-else slot="reference">
    <div style="margin: 0 3px;" class="popup-resa-detail-title" v-html="title"></div>
  </div>
</div>
